import { useTranslations } from "@jugl-web/utils";
import React from "react";

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  chatsCount: number;
  messages: number;
  infoIconSlot?: React.ReactNode;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  icon,
  label,
  chatsCount,
  messages,
  infoIconSlot,
}) => {
  const { t } = useTranslations();

  return (
    <div className="relative flex flex-1 flex-col items-center justify-center gap-3 rounded-xl border border-solid border-[#DEDEE4] bg-white p-5">
      <div className="flex items-center gap-2">
        {icon}
        <span className="font-secondary text-base font-medium text-[#1A2023]">
          {label}
        </span>
      </div>
      <div className="flex flex-col gap-2 font-secondary">
        <span className="text-[#1A2023]">
          <span className="text-base leading-[1.4] font-semibold">
            {chatsCount}
          </span>{" "}
          <span className="text-sm leading-[1.4] font-normal text-[#2C3438]">
            {t(
              {
                id: "cx-analytics.chats-count-label",
                defaultMessage: "{count, plural, one {chat} other {chats}}",
              },
              { count: chatsCount }
            )}
          </span>
        </span>
        <span className="text-[#1A2023]">
          <span className="text-base leading-[1.4] font-semibold">
            {messages}
          </span>{" "}
          <span className="text-sm leading-[1.4] font-normal text-[#2C3438]">
            {t(
              {
                id: "cx-analytics.messages-label",
                defaultMessage:
                  "{count, plural, one {message} other {messages}}",
              },
              { count: messages }
            )}
          </span>
        </span>
      </div>
      {infoIconSlot && (
        <div className="absolute top-4 right-4">{infoIconSlot}</div>
      )}
    </div>
  );
};
